import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  accountTypeTitle: {
    marginTop: spacing(8),
    marginBottom: spacing(3),
    color: colors.text.accent,
  },
  accountTypeBox: {
    display: 'flex',
    marginBottom: spacing(10),
  },
  sidebarContainer: {
    marginLeft: spacing(4),
    paddingLeft: spacing(2),
    borderLeft: `2px solid ${colors.layout.divider700}`,
  },
  chips: {
    marginLeft: spacing(2),
  },
  emojiIcon: {
    lineHeight: 0,
    height: 'auto',
    width: 'auto',
    verticalAlign: 'middle',
  },
  idGovUa: {
    marginTop: spacing(10),
    marginBottom: spacing(15),
  },
  hint: {
    marginTop: spacing(8),
  },
  hintText: {
    '& a': {
      color: colors.text.primary,
    },
  },
  text: {
    marginTop: spacing(5),
    marginBottom: spacing(4),
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridColumnGap: 20,
    alignItems: 'center',
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '4px',
    border: `2px solid ${colors.text.primary}`,
    color: colors.text.primary,
    cursor: 'pointer',

    '& button': {
      width: '100%',
      padding: spacing(2),
      '&:hover': {
        background: colors.layout.backgroundSecondary,
      },
    },
  },
  btnLogo: {
    marginLeft: spacing(2),

    '& path': {
      fill: colors.text.primary,
    },
  },
});

export default styles;
